import Vue from 'vue'

// axios TERMINAL
import axios from 'axios'
import store from '@/store/index'
const axiosIns = axios.create({

  // baseURL: 'http://localhost:8000/api',
  baseURL: 'https://api-staging.aequitex.com/api',
  // baseURL: 'https://api.aequitex.com/api',

  withCredentials: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-type': 'application/json',
    Authorization: `Bearer ${store.state.auth.token}`,
  },
})

Vue.prototype.$http = axiosIns

export default axiosIns
